import * as React from "react";

import { AppModalHeader } from "components/AppModal/AppModalHeader";

import { CalculatorType } from "models/payout";

import styles from "./CalculatorDetails.module.scss";
import { AppButton } from "components/AppButton";
import { useNavigate } from "react-router";
import { ROUTER_NAMES } from "router/routerNames";

interface Props {
  data: CalculatorType;
  disabled?: boolean;
  onClose?(): void;
}

export const CalculatorDetails: React.FC<Props> = ({
  data,
  disabled,
  onClose,
}) => {
  const navigate = useNavigate()

  return (
    <>
      <div className={styles.container}>
        <AppModalHeader onClose={onClose} title={data.plan.name} />
        <div className={styles.content}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Количество</th>
                <th>Бонус за план</th>
              </tr>
            </thead>
            <tbody>
              {data.plan.values.map(v => (
                <tr key={v.id}>
                  <td>{v.count}</td>
                  <td>{v.sum} с.</td>
                </tr>
              ))}
            </tbody>
          </table>

          <AppButton onClick={() => navigate(`${ROUTER_NAMES.CALCULATORS}/${data.id}`)}>
            Редактировать план
          </AppButton>
        </div>
      </div>
    </>
  );
};